import Form from "./Form.vue";

import Text from "./inputs/Text.vue";
import TextLocale from "./inputs/TextLocale.vue";
import Select from "./inputs/Select.vue";
import NumberInput from "./inputs/Number.vue";
import DateInput from "./inputs/Date.vue";
import Switch from "./inputs/Switch.vue";
import Cleave from "./inputs/Cleave.vue";
import Autocomplete from "./inputs/Autocomplete.vue";
import AutocompleteFetch from "./inputs/AutocompleteFetch.vue";
import Tag from "./inputs/Tag.vue";
import TagFetch from "./inputs/TagFetch.vue";
import Media from "./inputs/MediaLibrary.vue";
import RichText from "./inputs/RichText.vue";

export default {
  install(Vue, options) {

    Vue.component("v-form", Form);

    Vue.component("v-input", Text);
    Vue.component("v-input-locale", TextLocale);
    Vue.component("v-input-select", Select);
    Vue.component("v-input-number", NumberInput);
    Vue.component("v-input-date", DateInput);
    Vue.component("v-input-switch", Switch);
    Vue.component("v-input-cleave", Cleave);
    Vue.component("v-input-autocomplete", Autocomplete);
    Vue.component("v-input-autocomplete-fetch", AutocompleteFetch);
    Vue.component("v-input-tag", Tag);
    Vue.component("v-input-tag-fetch", TagFetch);
    Vue.component("v-input-media", Media);
    Vue.component("v-input-rich-text", RichText);
  }
};
